var React = require('react');

function IcLockOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 8.5h-1v-3c0-2.76-2.24-5-5-5s-5 2.24-5 5h2c0-1.66 1.34-3 3-3s3 1.34 3 3v3H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2Zm-12 12v-10h12v10H6Zm8-5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Z","fill":"currentColor"}));
}

IcLockOpen.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = IcLockOpen;

IcLockOpen.default = IcLockOpen;
